
import { LeftOutlined } from "@ant-design/icons"
import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from "antd"
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom"
import useRegistroAspiranteIndividual from "../../hooks/adminexamen/useRegistroAspiranteIndividual";

import { carreras } from "../../data/datos";


const { Option } = Select;


function RegistroAspiranteIndividual(){


    const { isLoading, onFinish, setPk_bachillerato,
            bachilleratos, setPkCarrera, valoresForm,
            form, verificarExistenciaPrematricula, estatusPrematricula,
            textoHelpPrematricula} = useRegistroAspiranteIndividual()

    return (
        <div>
            <Space direction="vertical">
                <Link to="/aspirantes">
                    <Button type="link" icon={<LeftOutlined />}>
                        Volver
                    </Button>
                </Link>
                <Link to="/subir-datos">
                    <Button type="link">Click aquí para cargar un excel</Button>
                </Link>
            </Space>

            {/* formulario */}
            <Row>
                <Col span={ 6 }></Col>
                <Col span={ 12 }>
                    <Form
                        form={ form }
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 16,
                        }}
                        name="registrar_aspirante"
                        onFinish={ onFinish }
                        autoComplete="off"
                        initialValues={ valoresForm }
                    >
                        {/* prematrícula */}
                        <Form.Item
                            hasFeedback
                            label="Prematrícula"
                            name="prematricula"
                            help={ textoHelpPrematricula }
                            validateStatus={ estatusPrematricula }
                            rules={[
                                {
                                    required: true,
                                    message: "Debe asignar una matrícula",
                                },
                            ]}
                        >
                            {/* aquí hice una desestructuración doble */}
                            <Input onChange={ ({ target: { value } }) => verificarExistenciaPrematricula( value )  } />
                        </Form.Item>

                        {/* nombre */}
                        <Form.Item
                            label="Nombre"
                            name="nombre"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un nombre",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* apellido paterno */}
                        <Form.Item
                            label="Apellido paterno"
                            name="apellido_p"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un apellido paterno",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* apellido materno */}
                        <Form.Item
                            label="Apellido materno"
                            name="apellido_m"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un apellido materno",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* ciclo examen */}
                        <Form.Item
                            label="Ciclo del examen"
                            name="ciclo_examen"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un ciclo de examen",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* fecha de alta */}
                        <Form.Item
                            label="Fecha de alta"
                            name="fecha_alta_universidad"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar una fecha de alta",
                                },
                            ]}
                        >
                            {/* <Input /> */}
                            <DatePicker allowClear={ false }/>
                        </Form.Item>

                        {/* sexo */}
                        <Form.Item
                            label="Sexo"
                            name="sexo"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un sexo",
                                },
                            ]}
                        >
                            <Select style={{ width: '100%' }}>
                                <Option value="Masculino">Masculino</Option>
                                <Option value="Femenino">Femenino</Option>
                            </Select>
                        </Form.Item>

                        {/* celular */}
                        <Form.Item
                            label="Celular"
                            name="celular"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un número de celular",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* correo */}
                        <Form.Item
                            label="Correo"
                            name="correo"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar un correo",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* curp */}
                        <Form.Item
                            label="Curp"
                            name="curp"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar una CURP",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        {/* escuela procedencia */}
                        <Form.Item
                            label="Escuela de procedencia"
                            name="nom_bachillerato"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar una escuela de procedencia",
                                },
                            ]}
                        >
                            <Select style={{ width: '100%' }} onChange={ ( e ) => {
                                setPk_bachillerato(e)
                                console.log(e);
                            }}>
                                { bachilleratos.map( b => (
                                    <Option key={ b.pk_bachillerato } value={ b.pk_bachillerato }>
                                        { b.nom_bachillerato }
                                    </Option>
                                )) }
                            </Select>
                        </Form.Item>

                        {/* carrera */}
                        <Form.Item
                            label="Carrera"
                            name="nom_carrera"
                            rules={[
                                {
                                    required: true,
                                    message: "Debes asignar una escuela de procedencia",
                                },
                            ]}
                        >
                            <Select style={{ width: '100%' }} onChange={ setPkCarrera }>
                                { carreras.map( e => (
                                    <Option value={ e.id } key={ e.id }>{ e.nom_carrera }</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            wrapperCol={{
                                offset: 8,
                                span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit" loading={ isLoading }>
                                Guardar datos
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
                <Col span={ 6 }></Col>
                <Toaster/>
            </Row>

        </div>
    )

}

export default RegistroAspiranteIndividual
